<template>
  <div>
    <div class="page-title-box">
      <div class="page-title-right">
        <permission name="ServiceCreate">
          <a href="javascript:void(0)" class="btn btn-primary" @click.prevent="showAddServiceModal"
             id="show-add-service-modal">
            <i class="mdi mdi-plus mr-1"></i><span>Lisa teenus</span>
          </a>
        </permission>
      </div>

      <h4 class="page-title">Teenuste haldus</h4>
    </div>

    <div class="card">
      <div class="card-body">
        <h4 class="header-title mt-0">Teenuste nimekiri</h4>
        <table class="table table-sm table-centered table-sticky table-hover mb-0">
          <thead>
          <tr>
            <th>Nimetus eesti keeles</th>
            <th>Nimetus inglise keeles</th>
            <th>Kategooria</th>
            <th>Booksi artikli number</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="service in services">
            <td>{{service.titleEst}}</td>
            <td>{{service.titleEng}}</td>
            <td>{{service.category}}</td>
            <td>{{service.excellentArticleCode}}</td>
            <td>
              <permission name="ServiceDeactivate">
                <button type="button" class="btn btn-link btn-sm float-right">
                  <i class="mdi mdi-delete" @click="deactivateService(service.id)"></i>
                </button>
              </permission>
              <permission name="ServiceUpdate">
                <button type="button" class="btn btn-link btn-sm float-right">
                  <i class="mdi mdi-pencil" @click="showUpdateServiceModal(service.id)"></i>
                </button>
              </permission>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <modal ref="addServiceModal" title="Lisa teenus" size="lg" @ok="loadServices">
      <add-service slot-scope="{close, visible}" @done="close" v-if="visible"/>
    </modal>

    <modal ref="updateServiceModal" title="Muuda teenust" size="lg" @ok="loadServices">
      <update-service :service-id="data" slot-scope="{close, visible, data}" @done="close" v-if="visible"/>
    </modal>

  </div>
</template>

<script>
  import Modal from '@/components/Modal'
  import AddService from '@/components/service/AddService'
  import UpdateService from '@/components/service/UpdateService'

  export default {
    components: {Modal, AddService, UpdateService},

    data() {
      return {
        services: []
      }
    },
    methods: {
      loadServices() {
        this.$gateway.get('/admin/services').then(r => this.services = r.data)
      },

      deactivateService(serviceId) {
        this.$confirm("Olete kindel, et soovite teenust kustutada?", () => {
          this.$gateway.delete(`/admin/services/${serviceId}`).then(() => {
            this.$notifications.info(`Teenus on kustutatud`)
            this.loadServices()
          });
        })
      },

      showUpdateServiceModal(serviceId) {
        this.$refs.updateServiceModal.show(serviceId)
      },

      showAddServiceModal() {
        this.$refs.addServiceModal.show()
      }
    },
    created() {
      this.loadServices()
    }
  }
</script>
